import { TranslationsInterface } from "../../interfaces/shared/TranslationsInterface";

export const mapTranslationsResponse = (response: {
    data: Record<string, string>;
}): TranslationsInterface => response.data;
